<template>
  <div class="itineraries-filters">
    <a-input-search
      v-model="searchValue"
      placeholder="Busque pelo código ou nome do roteiro"
      class="itineraries-filters__search"
      allow-clear
      @search="emitFilterChange"
      @change="onInputChange"
    >
      <a-icon slot="prefix" type="search" style="color: rgba(0, 0, 0, 0.25)" />
    </a-input-search>

    <BaseSegmentedTabs
      :tabs="statusTabs"
      :active-key="activeStatus"
      @change="onStatusChange"
    />
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import BaseSegmentedTabs from "@/shared/components/BaseSegmentedTabs.vue";

export default {
  name: "ItinerariesFilters",
  components: { BaseSegmentedTabs },
  props: {
    counts: {
      type: Object,
      default: () => ({ todos: 0, ativos: 0, inativos: 0 }),
    },
    activeStatus: {
      type: String,
      default: "todos",
    },
  },
  data() {
    return {
      searchValue: "",
    };
  },
  computed: {
    statusTabs() {
      return [
        { key: "todos", label: "Todos", count: this.counts.todos },
        { key: "ativos", label: "Ativos", count: this.counts.ativos },
        { key: "inativos", label: "Inativos", count: this.counts.inativos },
      ];
    },
  },
  created() {
    this.debouncedEmit = debounce(this.emitFilterChange, 500);
  },
  beforeDestroy() {
    this.debouncedEmit.cancel();
  },
  methods: {
    onInputChange() {
      this.debouncedEmit();
    },
    onStatusChange(key) {
      if (key === this.activeStatus) return;
      this.$emit("filter-change", { search: this.searchValue, status: key });
    },
    emitFilterChange() {
      this.$emit("filter-change", {
        search: this.searchValue,
        status: this.activeStatus,
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.itineraries-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 24px;

  &__search {
    width: 320px;

    /deep/ .ant-input {
      border-radius: 6px;
    }
  }
}
</style>
